export const SUPPORTED_LOCALES = [
  'en',
  'zh',
  'hi',
  'es',
  'fr',
  'ar',
  'bn',
  'pt',
  'ru',
  'ja',
  'it',
  'he',
  'de',
  'el',
  'pl',
] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export const DEFAULT_LOCALE: SupportedLocale = 'en'

const RTL_LOCALES = new Set<SupportedLocale>(['ar', 'he'])

export function getLocaleDirection(locale: string): 'ltr' | 'rtl' {
  const language = locale.toLowerCase().split('-')[0] as SupportedLocale
  return RTL_LOCALES.has(language) ? 'rtl' : 'ltr'
}

export function resolveAcceptLanguage(
  header: string | null | undefined,
  fallback: SupportedLocale = DEFAULT_LOCALE
): SupportedLocale {
  const supported = new Set<string>(SUPPORTED_LOCALES)
  const candidates = (header ?? '')
    .split(',')
    .map((entry, index) => {
      const [rawTag, ...parameters] = entry.trim().split(';')
      const qualityParameter = parameters.find((parameter) => parameter.trim().startsWith('q='))
      const quality = qualityParameter ? Number.parseFloat(qualityParameter.trim().slice(2)) : 1
      return {
        language: rawTag.trim().toLowerCase().split('-')[0],
        quality: Number.isFinite(quality) ? quality : 0,
        index,
      }
    })
    .filter(({ language, quality }) => language !== '*' && quality > 0 && supported.has(language))
    .sort((a, b) => b.quality - a.quality || a.index - b.index)

  return (candidates[0]?.language as SupportedLocale | undefined) ?? fallback
}
